import { ObjectUtil } from "@mcleod/core";
import { PropType } from "../..";
import { ComponentPropDefinitions, ComponentPropDefinitionUtil } from "../../base/ComponentProps";
import { PanelPropDefinitions, PanelProps } from "../panel/PanelProps";
import { layoutSelector } from "../textbox/TextboxProps";

export interface WidgetProps extends PanelProps {
  description: string;
  displayRefresh: boolean;
  layoutName: string;
  title: string;
}

let widgetPropDefs: ComponentPropDefinitions;

export class WidgetPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (widgetPropDefs == null) {
      widgetPropDefs = {
        ...PanelPropDefinitions.cloneDefs(),
        description: { type: PropType.string, description: "A description for this widget that will be displayed as a tooltip to let the user know what the widget does." },
        displayRefresh: { type: PropType.bool, defaultValue: false, description: "Specifies if the default refresh button will be displayed in the widget's default title bar."},
        layoutName: { type: PropType.string, editor: layoutSelector, description: "The path of an existing layout.  When supplied, the widget will display this layout."},
        busyWhenDataSourceBusy: { type: PropType.bool, defaultValue: true, description: "Specifies if a busy spinner should be displayed (in place of normal content) while data is being searched." },
        title: { type: PropType.string, description: "Specifies a title for the widget, which will be displayed in the widget's default title bar" }
      };
      ComponentPropDefinitionUtil.populateComponentPropNames(widgetPropDefs);
    }
    return widgetPropDefs;
  }

  public static cloneDefs(): ComponentPropDefinitions {
    return ObjectUtil.deepCopy(WidgetPropDefinitions.getDefinitions());
  }
}
